var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-logo"},[_c('transition',{attrs:{"name":"trs-simple-fade","mode":"out-in"}},[(_vm.currentLogo)?_c('img',{key:_vm.src,staticClass:"multi-logo--image",attrs:{"src":_vm.src}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }